import {
    type ExtrasFilterActionsType,
    EXTRASFILTER_APPLY_EXTRAS_FILTER,
    EXTRASFILTER_SET_AVAILABLE_ONLINE_TO_FILTER,
    EXTRASFILTER_SET_SEARCHSTRING,
    EXTRASFILTER_SET_TEMP_CATEGORIES_TO_FILTER,
    EXTRASFILTER_SET_TEMP_ROOT_CATEGORY_TO_FILTER,
    EXTRASFILTER_TOGGLE_EXTRAS_FILTER,
} from "../actions/ExtrasFilterActions";
import type { ExtrasCategoryToFilterType } from "../../../../../common-deprecated/types/CommonTypes";

export type ExtrasFilterStateType = {
    searchString: string;
    tempRootCategoryToFilter: ExtrasCategoryToFilterType | null;
    appliedRootCategoryToFilter: ExtrasCategoryToFilterType | null;
    availableOnlineToFilter: boolean | null;
    tempCategoriesToFilter: ExtrasCategoryToFilterType[];
    appliedCategoriesToFilter: ExtrasCategoryToFilterType[];
    showExtrasFilter: boolean;
};
export const initialState: ExtrasFilterStateType = {
    searchString: "",
    tempRootCategoryToFilter: null,
    appliedRootCategoryToFilter: null,
    availableOnlineToFilter: false,
    tempCategoriesToFilter: [],
    appliedCategoriesToFilter: [],
    showExtrasFilter: false,
};
export default (
    state: ExtrasFilterStateType = initialState,
    action: ExtrasFilterActionsType,
): ExtrasFilterStateType => {
    switch (action.type) {
        case EXTRASFILTER_SET_SEARCHSTRING: {
            const { searchString } = action;
            return { ...state, searchString };
        }
        case EXTRASFILTER_SET_TEMP_ROOT_CATEGORY_TO_FILTER: {
            const { tempRootCategoryToFilter } = action;
            return { ...state, tempRootCategoryToFilter };
        }
        case EXTRASFILTER_SET_AVAILABLE_ONLINE_TO_FILTER: {
            const { availableOnlineToFilter } = action;
            return { ...state, availableOnlineToFilter };
        }
        case EXTRASFILTER_SET_TEMP_CATEGORIES_TO_FILTER: {
            const { tempCategoriesToFilter } = action;
            return { ...state, tempCategoriesToFilter };
        }
        case EXTRASFILTER_APPLY_EXTRAS_FILTER: {
            const appliedCategoriesToFilter = state.tempCategoriesToFilter;
            const appliedRootCategoryToFilter = state.tempRootCategoryToFilter;
            return { ...state, appliedCategoriesToFilter, appliedRootCategoryToFilter, showExtrasFilter: false };
        }

        case EXTRASFILTER_TOGGLE_EXTRAS_FILTER: {
            return {
                ...state,
                showExtrasFilter: !state.showExtrasFilter,
                tempCategoriesToFilter: state.appliedCategoriesToFilter,
                tempRootCategoryToFilter: state.appliedRootCategoryToFilter,
            };
        }
        default:
            return state;
    }
};
